"use strict";

var _toConsumableArray = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrenciesInUse = void 0;

function getCurrenciesInUse(nftPricing) {
  var _a, _b, _c, _d;

  var hasReserve = nftPricing.reserve;

  if (hasReserve) {
    var auctionCurrencyId = (_a = nftPricing.reserve) === null || _a === void 0 ? void 0 : _a.auctionCurrency.id;

    if (auctionCurrencyId) {
      return [auctionCurrencyId];
    }
  }

  var bids = ((_c = (_b = nftPricing.perpetual) === null || _b === void 0 ? void 0 : _b.bids) === null || _c === void 0 ? void 0 : _c.map(function (bid) {
    return bid.pricing.currency.id;
  })) || [];
  var ask = (_d = nftPricing.perpetual.ask) === null || _d === void 0 ? void 0 : _d.pricing.currency.id;

  if (ask) {
    return [].concat(_toConsumableArray(bids), [ask]);
  }

  return bids;
}

exports.getCurrenciesInUse = getCurrenciesInUse;